export default "__VITE_ASSET__DOF2K9d5__"